<template>
  <BInputGroup size="sm">
    <BFormInput
      :model-value="modelValue"
      :placeholder="placeholder"
      :disabled="disabled"
      @update:model-value="handleInput"
      @keydown="handleKeyDown"
      class="search-input"
    />
    <template #append>
      <BButton
        variant="outline-secondary"
        class="search-button"
        @click="handleSearch"
        :disabled="!modelValue || disabled"
        size="sm"
      >
        <i class="bi bi-search"></i>
      </BButton>
    </template>
  </BInputGroup>
</template>

<script setup>
const props = defineProps({
  /**
   * 検索文字列の値（v-modelで双方向バインディング）
   * Vue 3ではmodelValueを使用
   */
  modelValue: {
    type: String,
    default: ''
  },
  /**
   * 入力フィールドのプレースホルダーテキスト
   */
  placeholder: {
    type: String,
    default: '検索...'
  },
  /**
   * 検索ボックスを無効化するかどうか
   */
  disabled: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['update:modelValue', 'search'])

/**
 * 入力値が変更された時の処理
 * Vue 3のv-modelのため、update:modelValueイベントを発火
 */
const handleInput = (value) => {
  emit('update:modelValue', value)
}

/**
 * キーダウンイベントハンドラ
 */
const handleKeyDown = (event) => {
  if (event.key === 'Enter') {
    handleSearch()
  }
}

/**
 * 検索実行時の処理
 * Enterキー押下または検索ボタンクリック時に発火
 */
const handleSearch = () => {
  // 入力が空の場合は検索しない
  if (!props.modelValue || props.modelValue.trim() === '') {
    return
  }
  emit('search', props.modelValue)
}
</script>

<style scoped>
/* 必要最小限のスタイル */
.search-input {
  border-right: 0;
  height: 31px; /* スモールサイズ統一 */
}

.search-button {
  background-color: white;
  border-color: #ced4da;
  color: #6c757d;
  border-left: 0;
  height: 31px; /* 入力フィールドと同じ高さ */
  padding: 0.25rem 0.5rem; /* スモールサイズパディング */
}

.search-button:hover {
  background-color: #f8f9fa;
  border-color: #adb5bd;
  color: #495057;
}

.search-button:disabled {
  background-color: #f8f9fa;
  border-color: #e9ecef;
  color: #adb5bd;
  opacity: 1;
  cursor: not-allowed;
}

.btn-outline-secondary {
  border-left: 0;
}

.btn-outline-secondary:hover {
  background-color: #6c757d;
  border-color: #6c757d;
  color: white;
}

.btn-outline-secondary:disabled {
  opacity: 1;
  cursor: not-allowed;
  background-color: #f8f9fa;
  border-color: #e9ecef;
  color: #adb5bd;
}

/* 無効化時の入力フィールドのスタイル */
.form-control:disabled {
  background-color: #f8f9fa;
  border-color: #e9ecef;
  color: #6c757d;
  opacity: 1;
}
</style>
